import { useMutation } from 'react-query';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import arrayBufferParse from '@/utils/functions/arrayBufferParse';
import { getAbcCurveReport } from './abcCurve.services';

interface Report {
  timestamp: string;
  status: number;
  error: string;
  path: string;
  message: string;
}

export function useAbcCurveReport() {
  return useMutation(getAbcCurveReport, {
    onSuccess() {
      notification.success({
        message: 'Relatório de curva ABC gerado com sucesso!',
      });
    },

    onError(error: AxiosError<Report>) {
      const response = arrayBufferParse<Report>(error.response?.data);

      notificationError(response);
    },
  });
}
